/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookies_Accept_AllInputs */

const en_cookies_accept_all = /** @type {(inputs: Cookies_Accept_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept all`)
};

const pl_cookies_accept_all = /** @type {(inputs: Cookies_Accept_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przyjmij wszystkie`)
};

/**
* | output |
* | --- |
* | "Accept all" |
*
* @param {Cookies_Accept_AllInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const cookies_accept_all = /** @type {((inputs?: Cookies_Accept_AllInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookies_Accept_AllInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_cookies_accept_all(inputs)
	return en_cookies_accept_all(inputs)
});